// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sq","controlPlay":"sr","controlElement":"ss","lowerControlWrapper":"st","lowerControlIconWrapper":"su","lowerControlIcon":"sv","show":"sw"};